// Event, Dialog
import EventBus from "@/event/EventBus";

// Api
import api from '@/api/baseApi';

// Constant
import { SETTINGS_RENTAL_API } from "@/constant/apiSettings";
import { POPUP_ID } from "@/constant/baseConstant";
import { API_CALL_STATUS } from "@/constant/baseConstant";

// Extend
import baseRentalService from '@/scripts/rentalService/baseRentalService';

export default {

    extends: baseRentalService,

    data() {

        return {
            request: {
                newName: null,
                fixedMacAddress: false,
                disconnectInternet: false,
                continueRunning: false
            },
        };
    },

    props: {
        targetImage: {
            type: Object,
            default: null,
        },
    },

    watch: {
        targetImage() {
            if(this.targetImage !== null)
            {
                this.request.newName = this.targetImage.name;
                this.request.fixedMacAddress = this.targetImage.hardwareFixation;
                this.request.disconnectInternet = this.targetImage.isDisconnectedInternet;
                this.request.continueRunning = this.targetImage.continueRunning;
            }
        }
    },
    mounted() {
        if(this.targetImage !== null)
        {
            this.request.newName = this.targetImage.name;
            this.request.fixedMacAddress = this.targetImage.hardwareFixation;
            this.request.disconnectInternet = this.targetImage.isDisconnectedInternet;
            this.request.continueRunning = this.targetImage.continueRunning;
        }
    },

    methods: {

        // Close this pop-up
        closeThisPopup() {
            this.closePopup(POPUP_ID.SETTINGS_MACHINE);
        },

        save() {
            this.feedStatusLoading(API_CALL_STATUS.LOADING);
            setTimeout(() => {
                let data = {
                    newName: this.request.newName,
                    machineId: this.targetImage.id,
                    fixedMacAddress: this.request.fixedMacAddress,
                    disconnectInternet: this.request.disconnectInternet,
                    actionAfterExpiry: this.request.continueRunning,
                    deviceInformation: JSON.stringify(this.getInformationClient())
                }
                api.baseRequest(SETTINGS_RENTAL_API.SETTINGS_MACHINE, data)
                    .then(() => {
                        EventBus.$emit("processingEventRental", { event: "isLoadingElement", data: [this.targetImage.id] });
                        EventBus.$emit("processingEventRental", { event: "autoRefresh" });
                        this.closeThisPopup();
                        this.notificationSuccess('Saved success !', `Machine <span style="color: #42A5F5;"> #${this.targetImage.id}</span> has been config successfully`);
                        this.feedStatusLoading(API_CALL_STATUS.SUCCESS);
                    })
                    .catch(error => {
                        this.processCatchApiRequest(error, "Save failed ...")
                    });
            }, this.smoothTimeOut);
        },
        //#endregion 
    },
}